export const INCOMING_EVENTS = [
    'click_use_template',
    'back_button_clicked',
    'loaded',
    'signup_redirect_url_update'
] as const;
